import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ExternalLinkModule } from '@psu-pennstateit-swe/utils/angular';

@Component({
  selector: 'cca-sidenav',
  imports: [ExternalLinkModule, MatIconModule, MatListItem, MatNavList, MatTooltipModule, RouterLink, RouterLinkActive],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SidenavComponent {}
